
import ModalButton from '@/components/UntitledUI/Button.vue'
import Modal from '@/components/common/Modals/Modal.vue'
import Icon from '@/components/UntitledUI/Icon.vue'

export default {
    name: 'TrialEndedModal',
    components: { ModalButton, Modal, Icon },
    props: {
        redirectOnClose: {
            type: Boolean,
            default: false
        }
    },
    methods: {
        startNow () {
            this.$router.push(this.localePath('/Packages'))
            this.close()
        },
        close () {
            if (this.redirectOnClose) {
                this.startNow()
            } else {
                this.$emit('close')
            }
        }
    }
}
